import type { StyleRule } from '@archipro-design/aria';
import {
    boxClassName,
    captionClassName,
    dividerClassName,
    inputClassName,
    inputSlotClassNames,
    textInputSlotClassNames,
} from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const SampleEnquiryForm: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: `1fr`,
    gap: pxToRem(10),
    [`& .${dividerClassName}`]: {
        display: 'none',
    },
    [`& .${textInputSlotClassNames.message}`]: {
        marginTop: pxToRem(8),
        [`&.${captionClassName}`]: {
            fontSize: pxToRem(14),
        },
    },
    [`& .${textInputSlotClassNames.primaryContent}`]: {
        background: theme.siteVariables.colors.white[200],
        [`& .${inputClassName}`]: {
            [`& > .${boxClassName}`]: {
                paddingBottom: 0,
                [`& .${inputSlotClassNames.input}`]: {
                    fontSize: `max(16px, ${pxToRem(16)})`,
                    lineHeight: theme.siteVariables.lineHeightSmall,
                    color: theme.siteVariables.colors.charcoal['250'],
                    alignSelf: 'center',
                },
                [`& textarea.${inputSlotClassNames.input}`]: {
                    alignSelf: 'flex-start',
                    minHeight: pxToRem(123),
                },
            },
        },
    },
});
